exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".message.message-success{background-color:#2ecc71}.message.message-error{background-color:#fe3824}.message-title{height:80px;line-height:80px}.message-title .message-msg{width:80%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 auto}.message-title .message-msg p{font-size:22px;color:#fff}.message-title .message-msg img{margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fcf144a4","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/Common/Message.vue
// module id = 424
// module chunks = 0